(function () {

    'use strict';

    angular.module('tmx-app').service('dynamicFormService', ['$rootScope', 'lookupService', 'tmxUtility', 'uuid', 'BroadcastService',
        function dynamicFormService($rootScope, lookupService, tmxUtility, uuid, BroadcastService) {
            var lookups;
            var fieldTypeLookup;
            var exists;
            var resolveAttr;
            var rootScope;
            var copy;
            var filter;
            var fieldMap = {};//specific to tmx scenario ofcourse, to speed up things
            var attachmentFieldTypes = ["checkbox_file","fingerprint"]
            var locationCaptureFields = ["maplocationcapture","locationcapture","addressmap"]
            var form = this;
            form.applicationData = {};
            form.applicationSLSandFRMUData = {};
            form.applicationGuarantorMappingData = {};
            form.guarantorTab = {};
            form.params = {};
            form.mapArray = [];
            form.tmxInput = tmxInput;
            form.tmxSelect = tmxSelect;
            form.tmxTreeView = tmxTreeView;
            form.tmxTextbox = tmxTextbox;
            form.tmxDatepicker = tmxDatepicker;
            form.tmxHtmlArea = tmxHtmlArea;
            form.tmxPageData = tmxPageData;
            form.tmxPageConfig = tmxPageConfig;
            form.tmxPage = tmxPage;
            form.loadPage = loadPage;
            form.fieldMap = fieldMap;
            form.bindRootObjectsToChildObjects = bindRootObjectsToChildObjects;
            form.makeArrayToObject = makeArrayToObject;
            form.takeOutAllChilds = takeOutAllChilds;
            form.removeEmptyObjects = removeEmptyObjects;
            form.tfsManipulation = tfsManipulation;
            lookups = lookupService;
            fieldTypeLookup = lookups.getReturnObject().lookups.FIELD;
            exists = tmxUtility.exists;
            resolveAttr = tmxUtility.resolveAttr;
            rootScope = $rootScope;
            copy = tmxUtility.copy;
            filter = tmxUtility.filter;


            function tmxInput(id, type, name, label, placeholder, value, events, classes, ngClassExp, validations, seq, table, isDisabled, parentId, errorControl, formula, locals, visibility, defaultValue) {
                var input = this;
                if (exists(id)) {
                    input.id = id
                }
                if (exists(parentId)) {
                    input.parentId = parentId
                }
                if (exists(type)) {
                    input.type = type
                }
                if (exists(name)) {
                    input.name = name
                }
                if (exists(label)) {
                    input.label = label
                }
                if (exists(placeholder)) {
                    input.placeholder = placeholder
                }
                if (exists(value)) {
                    input.value = value
                }
                if (exists(events)) {
                    input.events = events
                }
                if (exists(classes)) {
                    input.classes = classes
                }
                if (exists(ngClassExp)) {
                    input.ngClassExp = ngClassExp
                }
                if (exists(defaultValue)) {
                    input.defaultValue = defaultValue;
                }
                if (exists(errorControl)) {
                    input.errorControl = errorControl;
                }
                else {
                    input.errorControl = {
                        enable: true,
                        show: false
                    };
                }
                //each field can have a list of dependents
                input.dependants = new Set();
                //set up basic validations for an input in an array for treversal and map for easy accessing
                input.possibleValidations = { map: {} };
                input.possibleValidations.all = [
                    { name: "required", test: verifyRequiredRegular, message: function (field) { return field.label + " is a required field!" } },
                    { name: "pattern", test: verifyRegularPattern, message: function (field) { return field.label + " has invalid data!" } }
                ];
                input.possibleValidations.map.required = input.possibleValidations.all[0];
                input.possibleValidations.map.pattern = input.possibleValidations.all[1];

                //set up basic html capturing
                input.captureHTML = captureHTMLRegular;

                //set up basic error display mechanism
                input.updateHTML = updateHTMLRegular;
                //set locals
                if (!exists(locals)) {
                    input.locals = {};
                }
                else {
                    input.locals = locals;
                }
                input.locals.now = new Date();
                input.locals.IF = function (condition, value1, value2) {
                    if (condition) return value1;
                    else return value2;
                };
                input.locals.getLookupId = function (lookupType, hiddenValue) {
                    return lookups.getLookupIdByHiddenValueAndType(lookupType, hiddenValue);
                }
                input.locals.getLookupHiddenValue = function (lookupType, lookupId) {
                    //Parameter lookupType added to keep mobile & FE code uniform
                    var hiddenValue = lookups.getHiddenValueById(lookupId);
                    try {
                        if (hiddenValue) {
                            var num = Number(hiddenValue);
                            return isNaN(num) ? hiddenValue : num;
                        }
                        return hiddenValue;
                    }
                    catch (e) {
                        return hiddenValue;
                    }
                }
                input.locals.getLookupIdByIndex = function (lookupType, parentId, index) {
                    let lookupList;
                    if (!exists(parentId)) {
                        return null;
                    }
                    lookupList = lookups.getByTypeAndParentLocal(lookupType, parentId);
                    if (lookupList.length == 0) {
                        return null;
                    }
                    index = index || 0; // If index is not defined then set it to 0
                    index = index == -1 ? lookupList.length - 1 : index; // if index -1 then set it to the last element (as we dont know the size)
                    return lookupList[index].LookupId;
                }
                input.locals.concatenate = function () {
                    if (exists(arguments) && arguments.length > 0) {
                        return Array.from(arguments).join('');
                    }
                    return '';
                }
                input.locals.compare = function (value1, value2) {
                    return value1 === value2;
                }
                
                input.locals.datePart = function(fieldValue,part){
                    if(!exists(fieldValue) || !exists(part)){
                        return null;
                    }
                    var date = new Date(fieldValue);
                    switch(part.toLowerCase()){
                    case 'd':
                        return date.getDate();
                    case 'm':
                        return date.getMonth() + 1;
                    case 'y':
                        return date.getFullYear();
                    default:
                        return null;
                    }
                }
                input.locals.addTime = function(dateValue , offset, offsetType){
                    if(!exists(dateValue) || !exists(offset)){
                        return null;
                    }
                    var dateObj = new Date(dateValue);
                    if(!exists(offsetType)){
                        offsetType = 'd';
                    }
                    switch(offsetType.toLowerCase()){
                    case 'y':
                        dateObj.setFullYear(dateObj.getFullYear() + offset);
                        break;
                    case 'm':
                        dateObj.setMonth(dateObj.getMonth() + offset);
                        break;
                    case 'd':
                    default:
                        dateObj.setDate(dateObj.getDate() + offset);
                    }
                    return dateObj;
                }
                input.locals.dateCompare = function(obj1,operator,obj2){
                    if(!exists(obj1)|| !exists(obj2) || !exists(operator)){
                        return null;
                    }
                    var date1 = createDateObject(obj1);
                    var date2 = createDateObject(obj2);
                    switch(operator.toLowerCase()){
                    case 'eq':
                        return date1.getTime() == date2.getTime();
                    case 'lt':
                        return date1.getTime() < date2.getTime();
                    case 'gt':
                        return date1.getTime() > date2.getTime();
                    default: 
                        return false;
                            
                    }
                    function createDateObject(obj){
                        var dateMoment;
                        if(typeof obj === 'string' || obj instanceof String){
                            dateMoment = moment(obj,'YYYY-MM-DD')
                        }
                        else{
                            dateMoment = moment(obj);
                        }
                        return dateMoment.startOf('day').toDate();
                    }
                }
                input.locals.cnictogender = function (cnic) {
                    if (exists(cnic.length) && cnic.length == 13) {
                        if (cnic[cnic.length - 1] % 2 != 0) {//if last digit is odd
                            return "1";//then male
                        }
                        else {
                            return "2";//otherwise female
                        }
                    }
                    return undefined;//unset the gender
                };

                input.locals.round = function (value, decimals) {
                    return Number(value.toFixed(decimals));
                }
                if (exists(validations)) {
                    input.validations = validations;
                    if (exists(input, "validations.required") && input.validations.required != "true" && input.validations.required != "false") {//which means conditional required
                        input.conditionalRequired = makeFuncFromFormula("map", input.validations.required)//the function which resolves the conditional required
                    }
                    if (exists(input, "validations.maxlength")) {
                        input.validations.maxlength = makeFuncFromFormula("map", input.validations.maxlength)//the function which resolves the conditional maxlength
                        if(!exists(input.validations.maxlength.variables) || input.validations.maxlength.variables.length == 0){
                            // Incase the formula depends on TFS variables then the formula will be executed when the dependants are resolved
                            input.validations.maxlength.value = input.validations.maxlength.func({}, input.locals);
                        }
                    }
                    if (exists(input, "validations.minlength")) {
                        input.validations.minlength = makeFuncFromFormula("map", input.validations.minlength)//the function which resolves the conditional minlength
                        if(!exists(input.validations.minlength.variables) || input.validations.minlength.variables.length == 0){
                            // Incase the formula depends on TFS variables then the formula will be executed when the dependants are resolved
                            input.validations.minlength.value = input.validations.minlength.func({}, input.locals);
                        }
                    }
                }
                if (exists(seq)) {
                    input.seq = seq
                }
                if (exists(table)) {
                    input.table = table;
                    if (!exists(fieldMap[table])) fieldMap[table] = {};
                    fieldMap[table][name] = input;
                    input.tableObj = getTableObject(table);
                }
                if (exists(isDisabled)) {
                    /*      input.isDisabled=makeFuncFromFormula("map",isDisabled);
                          input.isDisabled.isExpression= ("return "+isDisabled != input.isDisabled.expression);
                          input.isDisabled.value=false;*/
                    var defaultIsDisabled = (isDisabled == "true" || isDisabled == "false") ? isDisabled == "true" : false;
                    input.isDisabled = makeFuncFromFormula("map", isDisabled);
                    input.isDisabled.isExpression = ("return " + isDisabled != input.isDisabled.expression);

                    // var rolenames = Object.values(JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles).map(function (x) { return x.name });
                    // //var rle= new RegExp("role==")
                    // if (isDisabled.includes("role==")) {
                    //     var role = isDisabled.slice(6, 8)
                    //     for (role in rolenames) {
                    //         defaultIsDisabled = "true";
                    //     }
                    // }
                    input.isDisabled.value = defaultIsDisabled;
                }
                if (angular.isDefined(visibility)) {
                    if (visibility == null)
                        visibility = "true";
                    var defaultIsVisible = (visibility == "true" || visibility == "false") ? visibility == "true" : false;
                    input.visibility = makeFuncFromFormula("map", visibility);
                    input.visibility.isExpression = ("return " + visibility != input.visibility.expression);
                    input.visibility.value = defaultIsVisible;
                }
                if (exists(table) && exists(name)) {
                    input.form_name = table + "_" + name;
                }

                if (exists(formula)) {
                    try {
                        // input.formula=makeFuncFromFormula("map",formula);
                        input.formula = makeFuncFromFormula("map", formula, input);
                    }
                    catch (e) {
                        console.log("error in making formula expression for TFS ID: "+input.id);
                        console.log(e);
                        // input.formula=makeFuncFromFormula("map",formula,input);
                        // input.formula=makeFuncFromFormula("map",formula);
                    }
                    input.hasFormula = true;
                }


                input.getViolated = function () {
                    return Array.from(input.violated);
                }
                input.otherValues = [];//stores other values that need to be computed when this field's value gets updated.. example, calculate age for each dob

                input.violated = new Set();

                input.checkViolations = function (value) {// calculate violations for a given value

                    input.captureHTML(input);//capture html
                    if (input.errorControl.enable) {
                        if (exists(input.validations) && Object.keys(validations).length > 0) {
                            //Check all validations
                            function verifyValidation(validation) {
                                validation.test(input, value);
                            }
                            input.possibleValidations.all.forEach(verifyValidation);

                            // update validity
                            input.isValid = input.violated.size == 0;
                            input.updateHTML(input, input.isValid);

                        }
                    }
                    else if (input.violated.size > 0) {
                        input.violated.clear();
                    }

                }

                input.getValue = function () {
                    return input.value;
                }


                input.setValidity = function (newValue, oldValue, scope, callback) {
                    if (input.errorControl.enable && !input.istabDisabled) {
                        var previousValidity = input.isValid;//record previous validity
                        input.checkViolations(newValue);//evaluate validity of field
                        if (exists(input.onValidityChange) && exists(input.isValid) && (previousValidity != input.isValid)) {//if validity has changed and there is some thing on validity change
                            input.onValidityChange(input);//perform that task
                        }
                    }
                    else if (input.violated.size > 0) {
                        input.violated.clear();
                    }
                    if (exists(callback)) callback(input);
                }

                input.setValidation = function (name, value) {
                    input.validations[name] = value;
                    input.setValidity(input.value);//update validity according to new validation
                }

                input.updateOtherValues = function (value, callback) {
                    function updateOtherValue(otherValue, index, arr) {
                        otherValue.func(value);// call the function defined to update that value
                        if (index == arr.length - 1 && angular.isFunction(callback)) {
                            callback();
                        }
                    }
                    input.otherValues.forEach(updateOtherValue);
                }

                input.evalFormula = function (map, formula) {
                    if (!exists(formula, "expression") || formula.expression.length == 0) return 0;
                    try {
                        var result = formula.func(map, input.locals);
                        if (result == 'Infinity') {
                            result = 0;
                        }
                    }
                    catch (e) {
                        console.log('Formula Execution Error on:' + input.id, input.formula);
                        console.error(e);
                    }
                    return result;
                }

                input.updateValue = function (value, map, must) {
                    if (value == 0 && input.type == "numeric") value = null;
                    if (attachmentFieldTypes.includes(input.type) && exists(value) && !angular.isDefined(input.attachment) && !value.includes('http')) input.attachment = value;
                    if (input.previousValue != value || must || angular.isObject(value)) {
                        input.value = value;
                        if (!exists(input.inputContainer) || input.inputContainer.length < 1) {
                            input.captureHTML(input);
                        }
                        if (exists(value) && exists(input.inputContainer) && input.inputContainer.length > 0) {
                            input.inputContainer.addClass('md-input-has-value');
                        }
                        input.setValidity(value);
                        if (input.otherValues.length > 0) {
                            input.updateOtherValues(value, function () {

                            });
                        }
                        if (exists(map)) {
                            input.dependants.forEach(function (dependant) {
                                switch (dependant.type) {
                                case "value":
                                    dependant.field.updateValue(dependant.field.evalFormula(map, dependant.field.formula), map, must);
                                    break;
                                case "disablility":
                                    dependant.field.isDisabled.value = dependant.field.evalFormula(map, dependant.field.isDisabled);
                                    break;
                                case "visibility":
                                    dependant.field.visibility.value = dependant.field.evalFormula(map, dependant.field.visibility);
                                    break;
                                case "maxlength":
                                    dependant.field.validations.maxlength.value = dependant.field.evalFormula(map, dependant.field.validations.maxlength);
                                    break;
                                case "minlength":
                                    dependant.field.validations.minlength.value = dependant.field.evalFormula(map, dependant.field.validations.minlength);
                                    break;
                                case "lookups":
                                    dependant.field.options.value = dependant.field.evalFormula(map, dependant.field.options);
                                    dependant.field.value = input.value == null ? dependant.field.value = null : dependant.field.value;
                                    break;
                                case "ischange":
                                    dependant.field.value = null;
                                    dependant.field.validations.required = true;
                                        // dependant.field.evalFormula(map,dependant.field.conditionalRequired);
                                    break;
                                case "hasChange":
                                    if (form.params.pageLoadComplete) {
                                        dependant.field.value = true;
                                        BroadcastService.publish('IsModifiedChange', "");
                                    }
                                    break;
                                }
                            });
                        }
                        input.previousValue = value;
                        if (map) {
                            form.mapArray = map;
                        }

                    }
                }

                input.setValidationRule = function (validation) {
                    var similarRule = input.possibleValidations.map[validation.name];
                    if (exists(similarRule)) {//if already exists
                        copy(validation, undefined, similarRule);//then copy all attributes
                    }
                    else {//otherwise create and add to map
                        input.possibleValidations.all.push(validation);
                        input.possibleValidations.map[validation.name] = validation;
                    }
                }

                input.removeValidationRule = function (name) {
                    var similarRule = input.possibleValidations.map[name];
                    if (exists(similarRule)) {//if exists
                        var indexInArray = input.possibleValidations.all.indexOf(similarRule);
                        input.possibleValidations.all.splice(indexInArray, 1);//remove it from all array
                        delete input.possibleValidations.map[similarRule.name];
                        input.violated.clear();
                        input.setValidity(input.value);//update is valid of field and page and all of the other stuff
                    }
                }

            }

            function formatgetTimeFormula(string) {
                string = string.replace(/ /g, '');
                var operator = string.match(/[+-]/g)[0];
                var map = string.split(operator)[0];
                var days = string.split(operator)[1].split('(').pop().split(')')[0];
                // eslint-disable-next-line no-useless-escape
                map = map.replace(/number/g, "date").replace(/\?0\:/g, "\?new Date(new Date().setDate(new Date().getDate()-" + days + "))\:");
                return 'new Date(new Date(' + map + ').setDate(' + map + '.getDate()' + operator + days + '))';
            }

            function makeFuncFromFormula(attrname, formula, input) {
                if (!isNaN(formula))
                    formula = formula.toString();

                formula = formula.replace(/ /g, '');
                var parse1 = ("return " + formula).replace(/(copyData|sum|length|min|max|count|average|getServiceChargesFromProduct|score|ischange)(\()(tf[0-9]+)(\))/g, function (match, p1, p2, p3) {
                    return p3 + "." + p1;
                });

                var parse2 = parse1.replace(/(tf[0-9]+)(\.[a-zA-Z]*){0,1}/g, function (match, p1, p2) {

                    p2 = p2 || "";
                    if (p2 == ".sum" || p2 == ".average" || p2 == ".max" || p2 == ".min" || p2 == ".count" || p2 == ".length") {// for aggregates and length
                        return "(( (map['" + p1 + "']?map['" + p1 + "']:{}).value ?map['" + p1 + "'].value:{})" + p2 + " || (map['" + p1 + "'].type == 'number'?0:''))";
                    }
                    else if (p2 == ".score") {
                        var mappingOne = "(map['" + p1 + "'].options.value.filter(obj=> {return obj.LookupId == map['" + p1 + "'].value;})[0])";
                        var mappingTwo = "(map['" + p1 + "'].options.value.filter(obj=> {return obj.LookupId == map['" + p1 + "'].value;})[0].HiddenValue)";
                        return "(map['" + p1 + "'].options.value?(parseInt((" + mappingOne + "?" + mappingTwo + ":0))):0)";
                    }
                    else if (p2 == ".ischange") {
                        return "'ischange'"; //Is change is in reverse form so we need its parameters to make a dictionary and will always return true in expression
                    }
                    else if (p2.length == 0 && !formula.includes('groupLookupBy')) {
                        return "((map['" + p1 + "']?map['" + p1 + "']:{}).value  || ((map['" + p1 + "'].type == 'number' || map['" + p1 + "'].type == 'amount')?0:''))";
                    }
                    else if (p2.length == 0 && formula.includes('groupLookupBy')) {
                        return "((map['" + p1 + "']?map['" + p1 + "']:{}).value  || (map['" + p1 + "'].type == 'number'?0:'')),map['tf" + input.id + "']";
                    }
                    else {//for rest of the functions
                        return "((map['" + p1 + "']?map['" + p1 + "']:{})" + p2 + " || ((map['" + p1 + "'].type == 'number' || map['" + p1 + "'].type == 'amount')?0:''))";
                    }
                });

                if (parse2.includes('getTime')) {
                    var tempArray = parse2.split(',');
                    tempArray.forEach(function (item, key) {
                        if (item.includes('getTime')) {
                            tempArray[key] = formatgetTimeFormula(item);
                        }
                    })
                    parse2 = tempArray.join(',');

                    parse2 = parse2.replace(/returnnow/g, 'new Date()');
                }

                if (parse2.includes(')!=null')) {
                    parse2 = parse2.replace(/!=null/g, '');
                }

                if (parse2.indexOf("now") > -1) {
                    // var date = new Date();
                    //parse2 = parse2.replace(/now/g, JSON.stringify(date)); changed bcz its creating issue in formula eval (-/+)
                    parse2 = parse2.replace(/now/g, 'new Date()');
                }

                if (parse2.indexOf("Math.round") > -1) {
                    parse2 = parse2.replace(/Math.round/g, 'round');
                }

                parse2 += ";";
                parse2 = parse2.replace(/if/g, 'IF');

                var codeToMakeLocalsAsGlobals = '\
                      if(!angular.isObject(locals)) locals={};\
                      var _keys=Object.keys(locals);\
                      for(var i=0;i<_keys.length;i++){\
                        var _code="var "+_keys[i]+" = locals."+_keys[i]+";";\
                        eval(_code);\
                      }';
                var parse3 = codeToMakeLocalsAsGlobals + parse2;    /*parse2.replace(/now/,"locals.now");*/
                var expression = parse2;
                var variables = Array.from(new Set(formula.match(/tf[0-9]+/g)));
                var func = new Function(attrname, "locals", parse3);
                return {
                    expression: expression,
                    variables: variables,
                    func: func,
                    basicFormula: formula
                };
            }
            // Validation rules for different input types...
            function verifyRequiredRegular(field, value) {
                if (field.errorControl.validations && field.errorControl.validations.required && exists(field.validations.required) && field.validations.required == "true" && (!exists(value) || value.length < 1)) {// required check
                    field.violated.add("required");//add required to violations
                }
                else {//otherwise
                    field.violated.delete("required");//remove it from violations
                }
            }
            function verifyRegularPattern(field, value) {
                if (angular.isDefined(value) && value != "" && field.pattern && field.pattern != "" && !(new RegExp(field.pattern).test(value))) {
                    field.violated.add("pattern");
                }
                else {
                    field.violated.delete("pattern");
                }
            }
            function verifyRequiredTable(field, value) {
                if (field.errorControl.validations && field.errorControl.validations.required && exists(field.validations.required) && field.validations.required == "true" && (!exists(value) || value.length < (field.validations.minLength ? field.validations.minLength : 1))) {// required check
                    field.violated.add("required");//add required to violations
                }
                else {//otherwise
                    field.violated.delete("required");//remove it from violations
                }
            }
            function verifyMaxTable(field, value) {
                if (field.errorControl.validations && exists(field.validations.maxLength) && exists(value) &&  value.length > field.validations.maxLength) {
                    field.violated.add("maxlength");
                }
                else {//otherwise
                    field.violated.delete("maxlength");//remove it from violations
                }
            }
            

            function verifyRequiredFileInput(field) {
                if (field.errorControl.validations.required && exists(field.validations.required) && field.validations.required == "true" && (!exists(field.value) || field.value.substring(0, 6) == "ignore") && !exists(field.attachment)) {// required check
                    field.violated.add("required");//add required to violations
                }
                else {//otherwise
                    field.violated.delete("required");//remove it from violations
                }
            }
            function verifyRequiredCheckbox(field) {
                if (field.errorControl.validations.required && exists(field.validations.required) && field.validations.required == "true" && (!exists(field.value) || Boolean(field.value) == false)) {// required check
                    field.violated.add("required");//add required to violations
                }
                else {//otherwise
                    field.violated.delete("required");//remove it from violations
                }
            }
            function verifyMaxlength(field, value) {
                if (field.errorControl.validations.maxlength && exists(field.validations.maxlength) && exists(value) && value.toString().length > field.validations.maxlength.value) {// maxlength check
                    field.violated.add("maxlength");//add required to violations
                }
                else {//otherwise
                    field.violated.delete("maxlength");//remove it from violations
                }
            }
            function verifyMinlength(field, value) {
                if (field.errorControl.validations.minlength && exists(field.validations.minlength) && exists(value) && value.toString().length < field.validations.minlength.value && value.toString().length > 0) {// minlength check
                    field.violated.add("minlength");//add required to violations
                }
                else {//otherwise
                    field.violated.delete("minlength");//remove it from violations
                }
            }

            function verifyMax(field, value) {
                if (field.errorControl.validations.maxlength && exists(field.validations.maxlength) && exists(value) && parseFloat(value) > parseFloat(field.validations.maxlength.value)) {// max check
                    field.violated.add("max");//add required to violations
                }
                else {//otherwise
                    field.violated.delete("max");//remove it from violations
                }
            }
            function verifyMin(field, value) {
                if (field.errorControl.validations.minlength && exists(field.validations.minlength) && exists(value) && parseFloat(value) < parseFloat(field.validations.minlength.value)) {// min check
                    field.violated.add("min");//add required to violations
                }
                else {//otherwise
                    field.violated.delete("min");//remove it from violations
                }
            }

            function captureHTMLRegular(field) { //Capturing html element for different input types...
                if (!exists(field.element) || field.element.length == 0 || !exists(field.inputContainer) || exists(field.inputContainer) && field.inputContainer.length == 0) {//if never rendered on screen before.. 
                    field.element = document.getElementsByName(field.form_name);//get it's element-- using form_name, since it is always unique
                    field.inputContainer = $(field.element).find("md-input-container");
                    field.input = $(field.element).find("input");
                }
            }

            function captureHTMLTable(field) {
                if (!exists(field.element) || !exists(field.header) || field.header.length == 0) {//if never rendered on screen before.. 
                    field.element = document.getElementsByName(field.form_name);//get it's element-- using form_name, since it is always unique
                    field.header = $(field.element).find(".k-header.k-grid-toolbar");
                }
            }


            //HTML updates to field according to its validity
            function updateHTMLRegular(field, validity) {
                if (field.errorControl.show && !validity) {// if error's are to be shown (determined via error control) and field is invalid
                    //display error
                    $(field.inputContainer).addClass("md-input-invalid");
                }
                else {
                    //undisplay errors xD
                    $(field.inputContainer).removeClass("md-input-invalid");
                }
            }

            function updateHTMLTable(field, validity) {
                if (field.errorControl.show && !validity) {// if error's are to be shown (determined via error control) and field is invalid
                    //display error
                    $(field.header).addClass("invalid-grid");
                }
                else {
                    //undisplay errors xD
                    $(field.header).removeClass("invalid-grid");
                }
            }

            function getTableObject(tname) {// to parse a tname like 'TmxSchoolAssetDetail{"AssetTypeLkp":6}'
                if (!exists(tname)) return undefined;
                var obj = {};
                var attrs;
                var i = tname.indexOf("{");
                if (i > -1 && tname.indexOf("}") + 1 == tname.length) {
                    attrs = JSON.parse(tname.substring(i));//attribute
                    tname = tname.substring(0, i);//table
                }
                obj["tname"] = tname;
                obj["query"] = attrs;
                return obj;// returns an object like {tname:"TmxSchoolAssetDetail", AssetTypeLkp:6}
            }
            // var sf1= new tmxSelect('TMX_COMPANY','_Field1','Company'); //possible declaration
            function tmxSelect(_id, _name, _label, _value, _lookupType, _seq, _required, _table, _disabled, parentId, errorControl, formula, locals, _events, _visibility, _defaultValue) {

                var returnInput = new tmxInput(_id, 'select', _name, _label, undefined, _value, _events, undefined, undefined, { required: _required }, _seq, _table, _disabled, parentId, errorControl, formula, locals, _visibility, _defaultValue);
                returnInput.options = {};
                function saveLookup(result, input) {
                    input.options.value = result;

                }
                if (exists(_lookupType)) {
                    if (_lookupType.indexOf("(") < 0) {//if normal lookup name then just get the loop
                        returnInput.options.value = lookups.getLocalLookupsByType(_lookupType);
                    }
                    else {//else it is a formula
                        returnInput.options = makeFuncFromFormula("map", _lookupType, returnInput);
                        if (!exists(returnInput.locals)) {
                            returnInput.locals = {};
                        }
                        returnInput.locals.groupLookupBy = function (lookupType, parentId, map) {
                            returnInput = map;
                            var response = lookups.getByTypeAndParentLocal(lookupType, parentId);

                            setTimeout(
                                saveLookup.bind(null, response, returnInput)
                                , 0);

                        };
                        if (!exists(returnInput, "options.variables")) {
                            returnInput.options.value = returnInput.options.func(null, returnInput.locals);
                        }
                    }
                }
                returnInput.lookType = _lookupType;
                return returnInput;
            }

            function tmxTreeView(_id, _name, _label, _value, _lookupType, _seq, _required, _table, _disabled, parentId, errorControl, formula, locals, _events, _visibility, _defaultValue) {
                var returnInput = new tmxInput(_id, 'treeview', _name, _label, undefined, _value, _events, undefined, undefined, { required: _required }, _seq, _table, _disabled, parentId, errorControl, formula, locals, _visibility, _defaultValue);
                returnInput.options = {};
                function saveLookup(result, input) {
                    input.options.value = result;

                }
                if (exists(_lookupType)) {
                    if (_lookupType.indexOf("(") < 0) {//if normal lookup name then just get the loop
                        var tempLookups = lookups.getLocalLookupsByType(_lookupType);
                        const result = [];
                        const map = new Map();
                        for (const item of tempLookups) {
                            if (!map.has(item.LookupId)) {
                                map.set(item.LookupId, true);    // set any value to Map
                                result.push({
                                    LookupId: item.LookupId,
                                    LookupName: item.LookupName,
                                    ParentLookupId: item.ParentLookupId,
                                    VisibleValue: item.VisibleValue,
                                    HiddenValue: item.HiddenValue,
                                });
                            }
                        }
                        returnInput.options.value = {
                            AggregateResults: null,
                            Data: lookups,
                            Errors: null,
                            Total: result.length,
                            data: result
                        }
                    }
                    else {//else it is a formula
                        returnInput.options = makeFuncFromFormula("map", _lookupType, returnInput);
                        if (!exists(returnInput.locals)) {
                            returnInput.locals = {};
                        }
                        returnInput.locals.groupLookupBy = function (lookupType, parentId, map) {
                            returnInput = map;
                            var response = lookups.getByTypeAndParentLocal(lookupType, parentId);

                            setTimeout(
                                saveLookup.bind(null, response, returnInput)
                                , 0);

                        };
                        if (!exists(returnInput, "options.variables")) {
                            returnInput.options.value = returnInput.options.func(null, returnInput.locals);
                        }
                    }
                }
                returnInput.lookType = _lookupType;
                return returnInput;
            }
            // eslint-disable-next-line no-unused-vars
            function setCharAt(str, index, chr) {
                if (index > str.length - 1) return str;
                return str.substr(0, index) + chr + str.substr(index + 1);
            }

            function tmxTextbox(_id, _name, _label, _value, _seq, _required, _maxLength, _minLength, _table, _disabled, _type, parentId, formula, locals, errorControl, _lookupType, _events, _placeholder, _visibility, _defaultValue) {
                var validations = {};
                validations.required = _required;
                if (exists(_maxLength)) {
                    if (_type == 'number' || _type == 'amount') {
                        if (_maxLength == 0) {
                            validations.maxlength = 0;
                        }
                        else if (_maxLength > 0) { // max length is a +ve value
                            validations.maxlength = Math.pow(10, _maxLength) - 1; //"1" + "0".repeat(_maxLength);
                        }
                        else { // max length is a -ve value
                            validations.maxlength = 0 - Math.pow(10, Math.abs(_maxLength) - 1);  //"-1"+"0".repeat(Math.abs(_maxLength)-1)
                        }
                    }
                    else {
                        validations.maxlength = _maxLength;
                    }

                }

                if (exists(_minLength)) {

                    if (_type == 'number' || _type == 'amount') {
                        if (_minLength > 0) {
                            validations.minlength = Math.pow(10, _minLength - 1); //"1" + "0".repeat(_minLength-1);
                        }
                        else if (_minLength < 0) {
                            validations.minlength = 0 - (Math.pow(10, Math.abs(_minLength)) - 1);//"1"+ "0".repeat(Math.abs(_minLength))
                        }
                        else {
                            validations.minlength = 0;
                        }
                    }
                    else {
                        validations.minlength = _minLength.toString();
                    }


                }

                if ((_type == 'number' || _type == 'rangenumber' || _type == 'numeric' || _type == 'amount') && _defaultValue) {
                    _defaultValue = parseInt(_defaultValue);
                }

                var returnInput = new tmxInput(_id, _type, _name, _label, undefined, _value, _events, undefined, undefined, validations, _seq, _table, _disabled, parentId, errorControl, formula, locals, _visibility, _defaultValue);
                if (returnInput.type == 'cnic') {
                    returnInput.getFromServer = (_lookupType ? _lookupType : "").toLowerCase() == "server";
                }
                if (returnInput.type == 'text' || returnInput.type == 'textarea' || returnInput.type == 'phone' || returnInput.type == 'numeric' || returnInput.type == 'alphabet' || returnInput.type == 'alpha' || returnInput.type == 'timestamp' || returnInput.type == 'locationcapture' || returnInput.type == 'addressmap') {
                    returnInput.setValidationRule({ name: "maxlength", test: verifyMaxlength, message: function (field) { return field.label + " should be at most " + field.validations.maxlength.value + " valid characters. Please remove atleast " + (field.value.length - field.validations.maxlength.value) + " charachter(s)."; } });
                    returnInput.setValidationRule({ name: "minlength", test: verifyMinlength, message: function (field) { return field.label + " should be at least " + field.validations.minlength.value + " valid characters. Please add atlease " + (field.validations.minlength.value - field.value.length) + " more charachter(s)."; } });
                }
                else if (returnInput.type == 'number' || returnInput.type == 'rangenumber' || returnInput.type == 'amount') {
                    returnInput.setValidationRule({ name: "max", test: verifyMax, message: function (field) { return field.label + " should be less than " + field.validations.maxlength.value + "."; } });
                    returnInput.setValidationRule({ name: "min", test: verifyMin, message: function (field) { return field.label + " should be greater than or equal to " + field.validations.minlength.value + "."; } });
                }
                return returnInput;
            }

            //table input type
            function tmxTable(_id, _name, _label, _seq, _required, _table, _disabled, parentId, errorControl, formula, _events, _visibility, _defaultValue, _minLength, _maxLength,_editState) {
                var validations = {};
                validations.required = _required;
                validations.minLength = _minLength;
                validations.maxLength =_maxLength;
                var returnInput = new tmxInput(_id, 'table', _name, _label, undefined, undefined, _events, undefined, undefined, validations, _seq, _table, _disabled, parentId, errorControl, formula, undefined, _visibility, _defaultValue);
                returnInput.gridOptions = new gridOptions(_table);
                returnInput.value = new kendo.data.ObservableArray([]);//hold value for a table
                returnInput.captureHTML = captureHTMLTable;//specific to table
                returnInput.updateHTML = updateHTMLTable;//specific to table
                returnInput.setValidationRule({ name: "required", test: verifyRequiredTable, message: function (field) { return field.label + " is a required table! It should have atleast " + (_minLength ? _minLength : 1) + " row(s)" } });
                returnInput.setValidationRule({ name: "maxlength", test: verifyMaxTable, message: function (field) { return field.label + " can have maximum of " + _maxLength + " row(s)" } });
                returnInput.editState = _editState;
                return returnInput;
            }

            function tmxHeader(_id, _name, _label, _seq, _visibility) {
                var returnInput = new tmxInput(_id, 'header', _name, _label, undefined, undefined, undefined, undefined, undefined, undefined, _seq, 'header', undefined, undefined, undefined, undefined, undefined, _visibility);
                return returnInput;
            }

            function tmxSignature(_id, _name, _label, _value, _seq, _required, _table, _disabled, parentId, errorControl, _events, _visibility, _defaultValue) {
                var returnInput = new tmxInput(_id, 'signature', _name, _label, '0', _value, _events, undefined, undefined, { required: _required }, _seq, _table, _disabled, parentId, errorControl, undefined, undefined, _visibility, _defaultValue);
                return returnInput;
            }

            function tmxFingerprint(_id, _name, _label, _value, _seq, _required, _table, _disabled, parentId, errorControl, _events, _visibility, _defaultValue) {
                var returnInput = new tmxInput(_id, 'fingerprint', _name, _label, '0', _value, _events, undefined, undefined, { required: _required }, _seq, _table, _disabled, parentId, errorControl, undefined, undefined, _visibility, _defaultValue);
                return returnInput;
            }

            function tmxHyperLink(_id, _name, _label, _value, _seq, _required, _table, _disabled, parentId, errorControl, _events, _visibility, _defaultValue) {
                var returnInput = new tmxInput(_id, 'hyperlink', _name, _label, '0', _value, _events, undefined, undefined, { required: _required }, _seq, _table, _disabled, parentId, errorControl, undefined, undefined, _visibility, _defaultValue);
                return returnInput;
            }

            function tmxObject(_id, _name, _table) {
                var returnInput = new tmxInput(_id, 'object', _name, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, _table, undefined, undefined);
                return returnInput;
            }
            function tmxEcib(_id, _name, _value, _seq, _label, errorControl, _table, _event, _visibility, _defaultValue) {
                var returnInput = new tmxInput(_id, 'ecib', _name, _label, undefined, _value, _event, undefined, undefined, undefined, _seq, _table, undefined, undefined, errorControl, undefined, undefined, _visibility, _defaultValue);
                return returnInput;
            }
            function tmxQuestion(_id, _name, _value, _seq, _required, _maxLength, _table, _disabled, _type, parentId, errorControl, _events, _placeholder, _visibility, _defaultValue) {
                var validations = {};
                validations.required = _required;
                if (_maxLength > 0) validations.maxlength = _maxLength;
                else if (_maxLength && _maxLength.indexOf(',') > 0) {
                    validations.maxlength = _maxLength.substr(0, _maxLength.indexOf(','));
                    validations.precision = _maxLength.substr(_maxLength.indexOf(',') + 1);
                }
                var returnInput = new tmxInput(_id, _type, _name, undefined, undefined, _value, _events, undefined, undefined, validations, _seq, _table, _disabled, parentId, errorControl, undefined, undefined, _visibility, _defaultValue);
                returnInput.setQuestion = function (questions) {
                    returnInput.question = filter(questions, returnInput.tableObj.query)[0];//keep the first match
                }
                returnInput.otherValues.push({
                    name: "updateScore",
                    decription: "calculate score according to current answer selected",
                    func: function (value) {
                        if (exists(returnInput, "question.Responses")) {
                            var matchedResponse = returnInput.question.Responses.filter(function (response) { return response[returnInput.name] == value; });
                            if (matchedResponse.length > 0) {
                                returnInput.score = matchedResponse[0].ResponseScoreValue;
                                return;
                            }
                        }
                        returnInput.score = 0;
                    }
                });
                return returnInput;
            }

            function gridOptions(table) {
                var rc = this;
                rc.table = table;
                rc.columns = [];
                rc.getColumns = function () {
                    function sortFields(f1, f2) {
                        return f1.seq - f2.seq;
                    }
                    var cols = [];
                    function makeColObj(field) {
                        var obj = {
                            field: field.name,
                            title: field.label,
                            hidden: !field.visibility.value,
                            editable: !field.isDisabled.value,
                            tfId: field.id,
                            type: field.type,
                        };
                        if (field.isAggregate) {
                            obj.aggregates = [field.aggregateType];
                            obj.footerTemplate = chooseTitleByAggr(field.aggregateType);
                        }
                        if (field.type == 'select' || field.type == 'treeview') {
                            obj.lookupType = field.lookType;
                            if(obj.lookupType.indexOf("(") > 0){
                                obj.options = makeFuncFromFormula("map", field.lookType, field);
                            }
                        }
                        else if (field.type == 'number' || field.type == 'amount' || field.type == 'rangenumber') {
                            field.type = 'number' // to make numeric and amount compatible with kendo 
                            obj.format = '{0:n2}';
                            obj.decimals = 2;
                            obj.step = 0.01;
                        }
                        else if (field.type == 'numeric') {
                            // field.type = 'number' // to make numeric and amount compatible with kendo 
                            // obj.format = '{0:n0}';
                            obj.decimals = 0;
                            obj.step = 1;
                        }
                        else if (field.type == 'date') {
                            obj.format = '{0:dd/MM/yyyy}';
                            obj.template = "#= kendo.toString(kendo.parseDate(" + field.name + ", 'yyyy-MM-dd'), 'dd/MM/yyyy')#"
                        }
                        else if (field.type == 'timestamp') {
                            field.type = 'date';
                            obj.format = "{0:MM/dd/yyyy h:mm tt}";
                            obj.template = "#= kendo.toString(kendo.parseDate(" + field.name + "), 'MM/dd/yyyy hh:mm tt')#"
                        }

                        if (field.formula && field.formula.basicFormula) {
                            let gridFormula = generateGridFormula(field.formula.basicFormula, cols);
                            obj.template = gridFormula.template;
                            obj.variables = gridFormula.variables;
                            obj.expression = gridFormula.expression;
                        }
                        
                        if (field.isDisabled && exists(field.isDisabled.variables) && field.isDisabled.variables.length>0) {
                            let gridFormula = generateGridFormula(field.isDisabled.basicFormula, cols);
                            obj.disableTemplate = gridFormula.template;
                            obj.disableVariables = gridFormula.variables;
                            obj.disableExpression = gridFormula.expression;
                        }
                        if (field.conditionalRequired && exists(field.conditionalRequired.variables) && field.conditionalRequired.variables.length>0) {
                            let gridFormula = generateGridFormula(field.conditionalRequired.basicFormula, cols);
                            obj.requiredTemplate = gridFormula.template;
                            obj.requiredVariables = gridFormula.variables;
                            obj.requiredExpression = gridFormula.expression;
                        }
                        if(field.defaultValue) {
                            obj.defaultValue = field.defaultValue;
                        }
                        cols.push(obj);
                    }
                    rc.columns.sort(sortFields).forEach(makeColObj);
                    cols.push({ command: ["edit", "destroy"], title: "&nbsp;", width: "250px" });//Add the delete column
                    return cols;
                }
                rc.getAggregates = function () {
                    var aggregate = [];
                    function makeAggrObj(field) {
                        if (field.isAggregate) {
                            aggregate.push({ field: field.name, aggregate: field.aggregateType.toLowerCase() });
                        }
                    }
                    rc.columns.forEach(makeAggrObj);
                    return aggregate;
                }

                function generateGridFormula(formula, cols) {
                    var tfIds = Array.from(new Set(formula.match(/tf[0-9]+/g)));
                    let fieldMap = {};
                    if (exists(tfIds)) {
                        fieldMap = resolveFieldNamesFromFormula(tfIds, cols);
                        tfIds.forEach(function (tfId) {
                            formula = formula.replace(new RegExp(tfId,'g'), fieldMap[tfId]);
                        });
                    }
                    var returnObj = {
                        variables: fieldMap,
                        template: "#= " + formula + " #"
                    };
                    let formulaExp = prepareFormulaFunc(formula);
                    if (formulaExp != null) {
                        returnObj.expression = formulaExp;
                    }

                    return returnObj;
                }

                function prepareFormulaFunc(formula) {
                    let complexFormulaFound = false;
                    let exp = '';
                    if (!isNaN(formula))
                        formula = formula.toString();

                    formula = formula.replace(/ /g, '');
                    if (formula.indexOf('if(') > -1) {
                        complexFormulaFound = true;
                        let tokens = formula.match(/if\(|([^),]+)|\)/g); // ["if(","tf123==123","x","y",")"]
                        exp = tokens[0] + tokens[1] + tokens[tokens.length - 1] + `{ 
                                    return ${tokens[2]}
                        }`; // "if(" + 'tf123==123' +")" + "x";
                        if (tokens[tokens.length - 1] != tokens[3]) {
                            exp += ` else {
                                return ${tokens[3]}
                            }`
                        }
                    }
                    if (complexFormulaFound) {
                        //return //"# if(1==1) { # 1 #} else {# 0 #} #"
                        return exp;
                    }
                    else {
                        return null;
                    }
                }

                function resolveFieldNamesFromFormula(tfIds, cols) {
                    let colIds = cols.map(x => '' + x.tfId); // convert to string
                    let namesMap = {};
                    tfIds.forEach(tf => {
                        let idx = colIds.indexOf(tf.replace('tf', ''));
                        namesMap[tf] = (idx > -1 ? cols[idx].field : '') // Returning the map of name and tfs id
                    });
                    return namesMap;
                }

                rc.getModel = function () {
                    // var rowIdentifier= rc.table.replace("Tmx","")+"Id";

                    var rowIdentifier = "";
                    if (rc.table.lastIndexOf('.') > 1) {
                        rowIdentifier = rc.table.substr(rc.table.lastIndexOf('.') + 1).replace("Tmx", "") + "Id";
                    }
                    else {
                        rowIdentifier = rc.table.replace("Tmx", "") + "Id";
                    }

                    // To handle the Id and ID problems
                    let definedCol = rc.columns.find(x => x.name.toLowerCase() == rowIdentifier.toLowerCase());
                    if (definedCol) {
                        rowIdentifier = definedCol.name;
                    }
                    var model = {
                        id: rowIdentifier,
                        fields: {}
                    };
                    function makeModelObj(field) {
                        model.fields[field.name] = {};
                        model.fields[field.name]["type"] = field.type;
                        model.fields[field.name]["validation"] = {};
                        model.fields[field.name]["editable"] = !field.isDisabled.value;
                        model.fields[field.name]["default_value"] = field.defaultValue;
                        //1- Set required for all kinds
                        if (resolveAttr(field, "validations.required") == 'true') {
                            model.fields[field.name].validation.required = true;
                        }
                        //2- For numbers set min and max if any
                        if (field.type == 'number' || field.type == 'numeric' || field.type == 'amount'|| field.type == 'text') {
                            if (exists(field, "validations.maxlength") && !isNaN(field.validations.maxlength.value)) {
                                model.fields[field.name].validation.max = field.validations.maxlength.value;
                            }
                            if (exists(field, "validations.minlength") && !isNaN(field.validations.minlength.value)) {
                                model.fields[field.name].validation.min = field.validations.minlength.value;
                            }
                        }
                    }
                    rc.columns.forEach(makeModelObj);
                    model.fields[rowIdentifier] = { type: "number" };
                    return model;
                }
            }
            function chooseTitleByAggr(aggr) {
                aggr = aggr.toLowerCase();
                switch (aggr) {
                case "count":
                    return "Total Count: #= count #";
                case "average":
                    return "Average: #= average #";
                case "sum":
                    return "Total Sum: #= sum #";
                case "min":
                    return "Minimum: #= min #";
                case "max":
                    return "Maximum: #= max #";
                }
            }
            function tmxDatepicker(_id, _name, _label, _value, _seq, _required, _table, _disabled, parentId, errorControl, formula, locals, _startdate, _enddate, _events, _visibility, _defaultValue) {
                if (!isNaN(_startdate) && _startdate != null) {
                    if (_startdate > 0)
                        _startdate = _startdate * -1;
                    _startdate = JSON.stringify(new Date(new Date().setDate(new Date().getDate() + parseInt(_startdate))));
                }

                if (!isNaN(_enddate) && _enddate != null)
                    _enddate = JSON.stringify(new Date(new Date().setDate(new Date().getDate() + parseInt(_enddate))));

                var validations = {
                    required: _required,
                    maxlength: _enddate,
                    minlength: _startdate
                };

                if (!exists(_required)) validations.required = "false";
                var returnInput = new tmxInput(_id, 'date', _name, _label, undefined, _value, _events, undefined, undefined, validations, _seq, _table, _disabled, parentId, errorControl, formula, locals, _visibility, _defaultValue);
                if (exists(_startdate)) {
                    returnInput.dateType = 'startdate';
                }

                _startdate = _startdate == "now" ? (new Date()).toJSON() : _startdate;
                _enddate = _enddate == "now" ? (new Date()).toJSON() : _enddate;
                returnInput.startdate = _startdate;
                returnInput.enddate = _enddate;
                if (_value)
                    returnInput.value = new Date(_value);
                return returnInput;
            }

            function tmxHtmlArea(_id, _name, _label, _value, _seq, _required, _table, _disabled, parentId, _startdate, _enddate, _events, _visibility, _defaultValue) {
                var returnInput = new tmxInput(_id, 'htmlarea', _name, _label, undefined, _value, _events, undefined, undefined, undefined, _seq, _table, _disabled, parentId, undefined, undefined, undefined, _visibility, _defaultValue);
                return returnInput;
            }


            function tmxCheckbox(_id, _name, _label, _value, _seq, _required, _table, _disabled, _type, parentId, errorControl, _formula, _events, _visibility, _defaultValue) {
                var validations = {
                    required: _required,
                };
                if (!exists(_required)) validations.required = "false";
                if (exists(_defaultValue)) {
                    // have to do number because tmxChecbox has 0 for off and 1 for on. 
                    // If we change to true/false value there, then change this cast to Boolean
                    _defaultValue = Number(_defaultValue);
                }
                var returnInput = new tmxInput(_id, _type, _name, _label, '0', _value, _events, undefined, undefined, validations, _seq, _table, _disabled, parentId, errorControl, _formula, undefined, _visibility, _defaultValue);
                returnInput.setValidationRule({ name: "required", test: verifyRequiredCheckbox });
                return returnInput;
            }
            function tmxFileInput(_id, _name, _label, _value, _seq, _required, _table, _disabled, _type, parentId, errorControl, _events, _visibility, _defaultValue) {
                var validations = {
                    required: _required,
                };
                if (!exists(_required)) validations.required = "false";
                var returnInput = new tmxInput(_id, _type, _name, _label, '0', _value, _events, undefined, undefined, validations, _seq, _table, _disabled, parentId, errorControl, undefined, undefined, _visibility, _defaultValue);
                returnInput.setValidationRule({ name: "required", test: verifyRequiredFileInput });
                return returnInput;
            }


            var TMX_DEFAULT_VALUE = {
                TEXT: "",
                NUMBER: 0,
                DATE: null
            }
            function isDefault(value) {
                if (exists(value)) {
                    if (value === TMX_DEFAULT_VALUE.TEXT || value === TMX_DEFAULT_VALUE.NUMBER || value === TMX_DEFAULT_VALUE.DATE) {
                        return true;
                    }
                }
                return false;
            }


            function tmxPageData(peripherals) {
                var pageData = this;
                pageData.fields = [];
                pageData.isValid = true;
                pageData.invalidFields = new Set();
                if (exists(peripherals)) {
                    pageData.peripherals = peripherals;
                }
                else {
                    pageData.peripherals = {};
                }

                pageData.verifyFields = function (callback) {
                    var i = 0;
                    pageData.fields.forEach(function (field, index, arr) {
                        field.setValidity(field.value, undefined, undefined, function () {
                            i++;
                            if (i == arr.length) {
                                callback();
                            }
                        })
                    });
                }

                pageData.getInvalidFields = function () {
                    return Array.from(pageData.invalidFields);
                }


                pageData.updateValidity = function (field) {// keep a track of field if invalid
                    if (exists(field.isValid) && field.isValid) {// if field has validity and it is true
                        if (pageData.isValid) {//and page is valid
                            //ignore as nothing changes
                        }
                        else {//however if page is been invalid
                            pageData.invalidFields.delete(field);//take it out of invalidField set.
                            pageData.isValid = pageData.invalidFields.size == 0;//page is valid if invalidField set is empty
                        }
                    }
                    else if (exists(field.isValid) && !field.isValid) {//otherwise
                        if (field.visibility && field.isDisabled && !field.isDisabled.value) {
                            pageData.invalidFields.add(field);//add it 
                            pageData.isValid = false;// and set pageData.valisValidid to false as it is certain
                        }
                    }
                }

                pageData.pushField = function (_field) {//push a _field add it to watch for monitring validity of field
                    pageData.fields.push(_field);//push the field
                    _field.onValidityChange = function (field) {//set a  
                        pageData.updateValidity(field);
                    } //update pagedata's validity when field's validity changes
                }

                pageData.read = function (resource, map) {
                    function fillField(field) {
                        var tData = getTableObject(field.table);
                        switch (field.type) {
                        case "alphanumeric":
                        case "text":
                        case "alphabet":
                        case "alpha":
                        case "textarea":
                        case "number":
                        case "date":
                        case "select":
                        case "treeview":
                        case "checkbox":
                        case "checkbox_file":
                        case "question":
                        case "cnic":
                        case "phone":
                        case "numeric":
                        case "signature":
                        case "email":
                        case "timestamp":
                        case "amount":
                        case "rangenumber":
                        case "fingerprint":
                        case "locationcapture":
                        case "addressmap":
                            {
                                if (tData.tname.includes('{')) {
                                    var count = tData.tname.match(/{/g).length;
                                    for (var i = 0; i < count; i++) {
                                        var key = tData.tname.substring(tData.tname.indexOf('{'), tData.tname.indexOf('}') + 1);
                                        var attr = key.match(/{"([^']+)":/)[1];
                                        var val = key.match(/:([^']+)}/)[1];
                                        var obj = resource[tData.tname.substring(0, tData.tname.indexOf('{'))];
                                        if (obj) {
                                            var index = obj.findIndex(x => x[attr] == val);
                                            if (index > -1) {
                                                tData.tname = tData.tname.replace(tData.tname.substring(tData.tname.indexOf('{'), tData.tname.indexOf('}') + 1), '[' + index + ']');
                                            }
                                        }
                                    }
                                }

                                if (exists(resource[tData.tname])) {//if resource has the object for field 
                                        // eslint-disable-next-line no-unused-vars
                                    pageData.readFieldFromResource(field, resource[tData.tname], map, function (field) {
                                    });
                                }
                                else {
                                    if (exists(field.formula))
                                        if (field.formula.variables == null || field.formula.variables.length == 0)
                                            field.value = field.formula.func();
                                }
                            }
                            break;
                        case "table":
                            if (exists(resource[field.table])) {
                                field.value = new kendo.data.ObservableArray(resource[field.table]);
                            }
                            break;
                        }

                        if (!exists(field.value)) {
                            if(exists(field.defaultValue)){
                                let lastUpdated = new Date(resource.LastUpdatedDate).getTime() || new Date().getTime(); // ||now  for the cases where resource doesnt have last updated time
                                let createdTime=new Date(resource.CreatedDate).getTime() || new Date().getTime();
                                if (Math.abs(lastUpdated - createdTime) < (30*1000)) { //30 second threshold for checking if the value is old or new
                                    if (field.defaultValue == "UUID") {
                                        if (field.value == null || !angular.isDefined(field.value))
                                            field.value = uuid.v4();
                                    }
                                    else if (field.type == 'date' && field.defaultValue != "") {
                                        if (field.defaultValue.indexOf("now") > -1)
                                            field.value = new Date();
                                        else if (field.defaultValue.match('^\\d{4}[-](0?[1-9]|1[0-2])[-](0?[1-9]|[12][0-9]|3[01])$'))
                                            field.value = field.defaultValue;
                                        else if (!isNaN(field.defaultValue)) {
                                            var dt = new Date();
                                            dt.setDate(dt.getDate() + field.defaultValue * 7);
                                            field.value = dt;
                                        }
                                    }
                                    else
                                        field.value = field.defaultValue;
                                }
                            }
                            else {
                                setFieldDefaultValues(field);
                            }
                        }
                        field.updateValue(field.value, map.primaryKey, true);//must update the first time

                    }
                    pageData.fields.forEach(fillField);
                }

                function setFieldDefaultValues(field) {
                    var value;
                    switch (field.type) {
                    case "number":
                        value = 0;
                        break;
                    case "amount":
                        value = 0;
                        break;
                    }
                    field.value = value;
                }

                pageData.write = function (resource, fillMandatory) {
                    function readField(field) {
                        switch (field.type) {
                        case "alphanumeric":
                        case "text":
                        case "alphabet":
                        case "alpha":
                        case "textarea":
                        case "number":
                        case "numeric":
                        case "date":
                        case "select":
                        case "treeview":
                        case "checkbox":
                        case "checkbox_file":
                        case "question":
                        case "cnic":
                        case "phone":
                        case "email":
                        case "signature":
                        case "timestamp":
                        case "amount":
                        case "rangenumber":
                        case "fingerprint":
                        case "locationcapture":
                        case "addressmap":
                            {
                                if (field.tableObj.tname.includes('{')) {
                                    var count = field.tableObj.tname.match(/{/g).length;
                                    for (var i = 0; i < count; i++) {
                                        var key = field.tableObj.tname.substring(field.tableObj.tname.indexOf('{'), field.tableObj.tname.indexOf('}') + 1);
                                        var attr = key.match(/{"([^']+)":/)[1];
                                        var val = key.match(/:([^']+)}/)[1];
                                        var parent = resource[field.tableObj.tname.substring(0, field.tableObj.tname.indexOf('{'))];
                                        if (exists(parent)) {
                                            var attrIndex = parent.findIndex(x => x[attr] == val);
                                            if (attrIndex == -1) {
                                                resource[field.tableObj.tname.substring(0, field.tableObj.tname.indexOf('{'))][0][attr] = val;
                                            }
                                        }
                                        var obj = resource[field.tableObj.tname.substring(0, field.tableObj.tname.indexOf('{'))];
                                        if (obj) {
                                            var index = obj.findIndex(x => x[attr] == val);
                                            if (index > -1) {
                                                field.tableObj.tname = field.tableObj.tname.replace(field.tableObj.tname.substring(field.tableObj.tname.indexOf('{'), field.tableObj.tname.indexOf('}') + 1), '[' + index + ']');
                                            }
                                        }
                                    }
                                }

                                pageData.insertFieldInResource(field, resource, fillMandatory);
                            }
                            break;
                        case "table":
                            if (field.isDisabled && !field.isDisabled.value) {
                                resource[field.table] = field.value;//decorateIgnored(field.value);
                            }
                            break;
                        }
                    }
                    pageData.fields.forEach(readField);
                }


                pageData.insertFieldInResource = function (field, resource, fillMandatory) {
                    var tData = field.tableObj;// first make the table object, seperates the tablename and query part
                    var obj = resource[tData.tname];
                    var query = tData.query;
                    if (!exists(obj)) {// if no such object exists in resource
                        resource[tData.tname] = [];//initialize it as a new array
                        obj = resource[tData.tname];// we'll use it for further work
                    }
                    if (exists(query) && obj.length > 0) {// if the field has a query associated with field and resource already has more than one some entries for this field
                        var keys = Object.keys(query);//get all keys of query
                        if (keys.length > 0) {
                            function satisfiesQuery(item) {//does the item matches query
                                var satisfies = true;//set matches to true initially
                                function satisfiesKey(key) {//then for each key of query
                                    satisfies = satisfies && (item[key] == query[key]);//check if the values are same in both query and item for the key
                                }
                                keys.forEach(satisfiesKey);
                                return satisfies;//satisfication that the item matches a query, true if matches whole query
                            }
                            obj = obj.filter(satisfiesQuery);// get the entries that match the quiries(note: this should be exactly 1 or 0 entry);
                        }
                    }
                    //Old Logic:Now the obj must contain only one item at max (in case of query:if we found a match, otherwise: it should already have one element at max)
                    //New Logic: If there was a discrepancy at server and there are multiple rows inserted for the same query, write the value in first of the rows that match the query
                    if (obj.length >= 1) {
                        obj[0][field.name] = pageData.decideValue(field, fillMandatory, obj[0][field.name]);//simply add the key value pair in the previous object
                        if (attachmentFieldTypes.includes(field.type)) {
                            obj[0]["Attachment"] = field.attachment;
                        }
                    }
                    else if (obj.length == 0) {//if there is no element in obj
                        var newObj = {};
                        newObj[field.name] = pageData.decideValue(field, fillMandatory);//insert the value
                        if (attachmentFieldTypes.includes(field.type)) {
                            newObj["Attachment"] = field.attachment;
                        }
                        copy(query, undefined, newObj);//copy all attributes from query to object (if any)

                        if (!resource[tData.tname].type) {
                            resource[tData.tname].push(newObj);
                        }
                    }
                }

                pageData.decideValue = function (field, fillMandatory, previousValue) {

                    if ((isNaN(field.value) && (field.type == 'amount' || field.type == 'number' || field.type == 'numeric')) || field.value === "" || (field.type == "checkbox_file") && exists(field.value) && field.value.indexOf("ignore") == 0)
                        delete field.value;
                    var value = field.value;
                    if (!exists(value) && isDefault(previousValue)) {
                        value = previousValue;
                    }
                    if (fillMandatory && !exists(value) && resolveAttr(field, "validations.required") == "true" && !pageData.isMust(field)) {//testing
                        switch (field.type) {
                        case "alphanumeric":
                        case "text":
                        case "alphabet":
                        case "alpha":
                        case "textarea":
                        case "checkbox":
                        case "checkbox_file":
                        case "cnic":
                        case "phone":
                        case "locationcapture":
                        case "addressmap":
                        case "timestamp":
                            value = TMX_DEFAULT_VALUE.TEXT;
                            break;
                        case "number":
                        case "amount":
                        case "question":
                            value = TMX_DEFAULT_VALUE.NUMBER;
                            break;
                        case "date":
                            value = TMX_DEFAULT_VALUE.DATE;
                            break;
                        case "select":
                            value = TMX_DEFAULT_VALUE.TEXT;
                            break;
                        case "treeview":
                            value = TMX_DEFAULT_VALUE.TEXT;
                            break;
                        case "table":
                            break;
                        }
                    }
                    return value;
                }

                pageData.isMust = function (field) {//return true if this should be ignored to prefill while saving
                    function check(id) {
                        return id == field.id;
                    }
                    var ignored = pageData.peripherals.mustFields.filter(check);
                    return ignored.length != 0;
                }

                pageData.readFieldFromResource = function (field, resource, map, callback) {
                    var tData = field.tableObj;// first make the table object, seperates the tablename and query part
                    var query = tData.query;
                    if (exists(query)) {// if field has a query attached
                        var keys = Object.keys(query);//get all keys of query
                        if (keys.length > 0) {//a valid query
                            function satisfiesQuery(item) {//does the item matches query
                                var satisfies = true;//set matches to true initially
                                function satisfiesKey(key) {//then for each key of query
                                    satisfies = satisfies && (item[key] == query[key]);//check if the values are same in both query and item for the key
                                }
                                keys.forEach(satisfiesKey);
                                return satisfies;//satisfication that the item matches a query, true if matches whole query
                            }
                            resource = resource.filter(satisfiesQuery);// get the entries that match the quiries(note: this should be exactly 1 or 0 entry);
                        }
                    }
                    if (exists(resource[0]) && exists(resource[0][field.name])) {//else if it is a simple field and resource has some data for it and that value is not a default
                        var value;
                        switch (field.type) {
                        case "number":
                            value = parseFloat(resource[0][field.name]);//fill the field with value
                            break;
                        case "amount":
                            value = parseFloat(resource[0][field.name]);//fill the field with value
                            break;
                        case "date":
                            value = new Date(resource[0][field.name]);
                            break;
                        default:
                            value = resource[0][field.name];//fill the field with value
                        }
                        field.value = value;
                        callback(field);
                    }
                    else {
                        if (exists(field.formula))
                            if (field.formula.variables == null || field.formula.variables.length == 0)
                                field.value = field.formula.func();
                    }
                }
            }


            function tmxPageConfig(cols) {
                var config = this;
                config.cols = cols;
            }

            function tmxPage(_id, _title, peripherals, _pageData, _config, _tabs, _defaultValue) {
                var page = this;
                page.isValid = true;
                page.invalidTabs = new Set();

                if (exists(_id)) {
                    page.id = _id;
                }
                if (exists(_title)) {
                    page.title = _title;
                }
                if (exists(_defaultValue)) {
                    page.defaultValue = _defaultValue;
                }

                if (exists(_pageData)) {
                    page.pageData = _pageData;
                }
                else {
                    page.pageData = new tmxPageData(peripherals);
                }
                if (exists(_config)) {
                    page.config = _config;
                }
                else {
                    page.config = new tmxPageConfig(3);
                }
                if (exists(_tabs)) {
                    page.tabs = _tabs;
                }
                else {
                    page.tabs = [];
                }
                if (exists(peripherals)) {
                    page.peripherals = peripherals;
                }
                else {
                    page.peripherals = {};
                }
                function getSelfValid() {
                    return page.pageData.isValid;
                }

                function updateValidity(isValid) {//page is valid if its pageData is valid and it has no invalid tabs
                    if (exists(isValid)) {
                        page.isValid = isValid && page.invalidTabs.size == 0;
                    }
                }
                updateValidity(getSelfValid());//initialize

                rootScope.$watch(getSelfValid, updateValidity);//put a watch to mantain this

                page.verify = function (callback) {
                    var selfVerified = page.pageData.fields.length == 0;
                    var tabsVerified = page.tabs.length == 0;
                    var noTabs = 0;
                    function selfVerify() {
                        selfVerified = true;
                        if (selfVerified && tabsVerified) {
                            allVerified();
                        }
                    }
                    function tabsVerify(tab) {
                        function onTabVerify() {
                            if (noTabs == page.tabs.length) {
                                tabsVerified = true;
                                page.invalidTabs.clear();//empty any preious list
                                page.tabs.forEach(function (tab) {//update invalid tabs
                                    if (!tab.isValid) {
                                        page.invalidTabs.add(tab);
                                    }
                                });
                            }
                            if (tabsVerified && selfVerified) {
                                allVerified();
                            }
                        }
                        if (tab.skipTabInPageValidation == true || tab.defaultValue == 'Guarantors') { // Skip the tabs for which we explicitly set the skip flag
                            return;
                        }
                        noTabs++;
                        tab.verify(onTabVerify);
                    }
                    function allVerified() {//to run if every one verified
                        updateValidity(getSelfValid());//update validity
                        callback();
                    }
                    page.pageData.verifyFields(selfVerify);//verify itself
                    page.tabs.forEach(tabsVerify);//verify all tabs
                }

                page.insertTab = function (tab) {
                    if (tab.defaultValue != 'ParentObjects') {
                        page.tabs.push(tab);
                        function updateInvalidTabs(isValid) {
                            if (isValid) {//if tab is valid
                                page.invalidTabs.delete(tab);//take it out of invalidTabs set.
                                page.isValid = page.pageData.isValid && page.invalidTabs.size == 0;//page is valid if invalidTabs set is empty

                            }
                            else {//otherwise
                                page.invalidTabs.add(tab);//add it 
                                page.isValid = false;// and set page.isValid to false as it is certain
                            }
                        }
                        function getTabValidity() {
                            return tab.isValid;
                        }
                        updateInvalidTabs(getTabValidity());//initialize
                        rootScope.$watch(getTabValidity, updateInvalidTabs);
                    }
                }
                page.getInvalidTabs = function () {
                    return Array.from(page.invalidTabs);
                }

                page.read = function (resource, map) {
                    page.pageData.read(resource, map);
                    function readTab(tab) {
                        tab.read(resource, map);
                    }
                    page.tabs.forEach(readTab);
                }

                page.write = function (resource, fillMandatory) {
                    page.pageData.write(resource, fillMandatory);
                    function writeTab(tab) {
                        tab.write(resource, fillMandatory);
                    }
                    page.tabs.forEach(writeTab);
                }

                page.registerDependants = function () {// registers fields dependenet on one another
                    page.fieldMap.all.forEach(function (dependant) {
                        if (dependant.hasFormula) {
                            if (dependant.formula.expression.includes('ischange')) {
                                if (exists(dependant.formula.variables)) {
                                    dependant.formula.variables.forEach(function (dependancyId) {
                                        registerVariable(page, "hasChange", dependant, dependancyId);
                                    });
                                }
                            }
                            else if (dependant.formula.expression.includes('copyData')) {
                                if (exists(dependant.formula.variables)) {
                                    dependant.formula.variables.forEach(function (dependancyId) {
                                        registerVariable(page, "copyData", dependant, dependancyId);
                                    });
                                }
                            }
                            else {
                                if (exists(dependant.formula.variables)) {
                                    dependant.formula.variables.forEach(function (dependancyId) {
                                        registerVariable(page, "value", dependant, dependancyId);
                                    });
                                }
                            }
                        }

                        //if field has condiltional disability
                        if (exists(dependant, "isDisabled.variables") && dependant.isDisabled.variables.length > 0) {
                            dependant.isDisabled.variables.forEach(function (dependancyId) {
                                registerVariable(page, "disablility", dependant, dependancyId);
                            });
                        }
                        //if field has condiltional visiblity
                        if (exists(dependant, "visibility.variables") && dependant.visibility.variables.length > 0) {
                            dependant.visibility.variables.forEach(function (dependancyId) {
                                registerVariable(page, "visibility", dependant, dependancyId);
                            });
                        }
                        //if field has condiltional lookups
                        if (exists(dependant, "options.variables") && dependant.options.variables.length > 0) {
                            dependant.options.variables.forEach(function (dependancyId) {
                                registerVariable(page, "lookups", dependant, dependancyId);
                            });
                        }
                        //if field has condiltional maxlength
                        if (exists(dependant, "validations.maxlength.variables") && dependant.validations.maxlength.variables.length > 0) {
                            dependant.validations.maxlength.variables.forEach(function (dependancyId) {
                                registerVariable(page, "maxlength", dependant, dependancyId);
                            });
                        }
                        //if field has condiltional minlength
                        if (exists(dependant, "validations.minlength.variables") && dependant.validations.minlength.variables.length > 0) {
                            dependant.validations.minlength.variables.forEach(function (dependancyId) {
                                registerVariable(page, "minlength", dependant, dependancyId);
                            });
                        }
                        if (dependant.type.toLowerCase() == 'signature') {
                            if (exists(dependant, "conditionalRequired.variables") && dependant.conditionalRequired.variables.length > 0) {
                                if (exists(dependant, "validations.required") && dependant.validations.required.includes("ischange")) {
                                    dependant.conditionalRequired.variables.forEach(function (dependancyId) {
                                        registerVariable(page, "ischange", dependant, dependancyId);
                                    });
                                }
                            }
                        }
                        if (dependant.type.toLowerCase() == 'fingerprint') {
                            if (exists(dependant, "conditionalRequired.variables") && dependant.conditionalRequired.variables.length > 0) {
                                if (exists(dependant, "validations.required") && dependant.validations.required.includes("ischange")) {
                                    dependant.conditionalRequired.variables.forEach(function (dependancyId) {
                                        registerVariable(page, "ischange", dependant, dependancyId);
                                    });
                                }
                            }
                        }
                    });
                }

                function registerVariable(page, type, dependant, dependancyId) {
                    if (("tf" + dependant.id) != dependancyId) {
                        var dependancy = page.fieldMap.primaryKey[dependancyId];//get the dependancy field
                        if (exists(dependancy)) {// if it exists
                            dependancy.dependants.add({ field: dependant, type: type });//add the dependant field to dependants list of dependancy
                        }
                    }
                }

            }
            function loadPage(page, fieldMap, errorControl, peripherals) {
                decoratePage(page);
                var form = new tmxPage(page.id, page.title, peripherals, undefined, undefined, undefined, page.DefaultValue);
                if (!exists(fieldMap)) {//if no map provided by parent
                    fieldMap = { primaryKey: {}, all: [], tname: {} };//then make your own, as you are a careful page
                }
                form.fieldMap = fieldMap;//hold to map, as you may also pass it to your child page
                function pushFields(_field) {
                    _field.FieldName = _field.FieldName ? _field.FieldName.trim() : "";
                    decorateField(_field);
                    var field;
                    var invalidField = false;
                    _field.FieldLabel = _field.LocalizedLabel == null ? _field.FieldLabel : _field.LocalizedLabel;
                    //set value of isMandatory
                    if (_field.IsMandatory == 1)
                        _field.IsMandatory = "true"
                    else if (exists(_field.IsMandatory) && _field.IsMandatory.length > 1) {
                        //is an expression-- do nothing
                    }
                    else
                        _field.IsMandatory = "false";
                    if (_field.IsDisabled == 1)
                        _field.IsDisabled = "true";
                    else if (exists(_field.IsDisabled)) {
                        if(_field.IsDisabled.length > 1){
                        //is an expression-- do nothing
                        }
                        else {
                            _field.EditState = _field.IsDisabled; //to disable row addition/deletion
                        }
                    }
                    else
                        _field.IsDisabled = "false";
                    if (_field.Visibility == 0)
                        _field.Visibility = "false";
                    else if (exists(_field.Visibility) && _field.Visibility.length > 1) {
                        // is an expression Do nothing
                    }
                    else
                        _field.Visibility = "true";
                    if(locationCaptureFields.includes(_field.type) ){ // Dont consider default value for location capture fields
                        _field.DefaultValue = null;
                    }
                    // These fields ahave different implementation on mobile side but are simple text fields on portal
                    if (_field.type == 'name' || _field.type == 'maplocationcapture')
                        _field.type = 'text';

                    if (_field.type == 'text' || _field.type == 'textarea' || _field.type == 'number' || _field.type == 'numeric' || _field.type == 'rangenumber' || _field.type == 'cnic' || _field.type == 'phone' || _field.type == "email" || _field.type == "alphabet" || _field.type == "alpha" || _field.type == "timestamp" || _field.type == 'amount' || _field.type == 'locationcapture' || _field.type == 'addressmap') {

                        field = tmxTextbox(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldLength, _field.MinLength, _field.FieldTableName, _field.IsDisabled, _field.type.toLowerCase(), _field.ParentTenantFieldSetupId, _field.Formula, peripherals.locals, errorControl, _field.FieldLookupType, undefined, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'dropdown' || _field.type == 'searchabledropdown') {
                        field = tmxSelect(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldLookupType, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, errorControl, _field.Formula, peripherals.locals, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type.toLowerCase() == 'tree') {
                        field = tmxTreeView(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldLookupType, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, errorControl, _field.Formula, peripherals.locals, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'datetime') {
                        field = tmxDatepicker(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, errorControl, _field.Formula, peripherals.locals, _field.MinLength, _field.FieldLength, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'checkbox') {
                        field = tmxCheckbox(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.type, _field.ParentTenantFieldSetupId, errorControl, _field.Formula, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'checkbox_file') {
                        field = tmxFileInput(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.type, _field.ParentTenantFieldSetupId, errorControl, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'table') {
                        field = tmxTable(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, errorControl, _field.Formula, undefined, _field.Visibility, _field.DefaultValue, _field.MinLength,_field.FieldLength,_field.EditState);
                    }
                    else if (_field.type == 'header') {
                        field = tmxHeader(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.FieldSequence, _field.Visibility);
                    }
                    else if (_field.type == 'signature') {
                        field = tmxSignature(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, errorControl, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'fingerprint') {
                        field = tmxFingerprint(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, errorControl, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'hyperlink') {
                        field = tmxHyperLink(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, errorControl, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'object') {
                        field = tmxObject(_field.TenantFieldSetupId, _field.FieldName, _field.FieldTableName);
                    }
                    else if (_field.type == 'question') {
                        field = tmxQuestion(_field.TenantFieldSetupId, _field.FieldName, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldLength, _field.FieldTableName, _field.IsDisabled, _field.type.toLowerCase(), _field.ParentTenantFieldSetupId, errorControl, undefined, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type == 'htmlarea') {
                        field = tmxHtmlArea(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, undefined, undefined, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else if (_field.type.indexOf('aggregate') == 0) {
                        field = tmxDatepicker(_field.TenantFieldSetupId, _field.FieldName, _field.FieldLabel, _field.value, _field.FieldSequence, _field.IsMandatory, _field.FieldTableName, _field.IsDisabled, _field.ParentTenantFieldSetupId, errorControl, _field.Formula, peripherals.locals, _field.MinLength, _field.FieldLength, undefined, _field.Visibility, _field.DefaultValue);
                        field.isAggregate = true;
                        field.aggregateType = _field.type.substring('aggregate'.length);
                    }
                    else if (_field.type == 'ecib') {
                        field = tmxEcib(_field.TenantFieldSetupId, _field.FieldName, _field.value, _field.FieldSequence, _field.FieldLabel, errorControl, _field.FieldTableName, undefined, _field.Visibility, _field.DefaultValue);
                    }
                    else {
                        invalidField = true;
                    }
                    if (!invalidField) {
                        field.istabDisabled = _field.istabDisabled;
                        if (exists(field.parentId)) {//has a parent
                            if (exists(form.fieldMap.primaryKey[formatFieldID(field.parentId)])) {// and parent exists in fieldMap (which means that either the parent field has already been made by the time we encounter this field)
                                if (Array.isArray(form.fieldMap.primaryKey[formatFieldID(field.parentId)])) {//is a bag, parent has still not been encountered
                                    form.fieldMap.primaryKey[formatFieldID(field.parentId)].push(field)
                                }
                                else {
                                    if (form.fieldMap.primaryKey[formatFieldID(field.parentId)].type == "table") {// and the type of parent is table
                                        form.fieldMap.primaryKey[formatFieldID(field.parentId)].gridOptions.columns.push(field);
                                        field.value = {};//this will store aggregates later
                                    }
                                }
                            }
                            else {//parent hasn't been made yet, so we store it in the bag for the parent field..
                                form.fieldMap.primaryKey[formatFieldID(field.parentId)] = [field];
                            }
                        }
                        else {//has no parent
                            form.pageData.pushField(field);
                            if (Array.isArray(form.fieldMap.primaryKey[formatFieldID(field.id)])) {//means there was a bag of fields, a bag filled with fields which have parentId has this field's primary key
                                if (field.type == "table") {//for now, we only know how to deal a bag for table type...
                                    function dealWithField(aField) {
                                        field.gridOptions.columns.push(aField);
                                        aField.value = {};//this will store aggregates later
                                    }
                                    form.fieldMap.primaryKey[formatFieldID(field.id)].forEach(dealWithField);
                                }
                            }
                        }
                        form.fieldMap.primaryKey[formatFieldID(field.id)] = field;// map with primary keys
                        form.fieldMap.all[field.id] = field;// an arrray that contains all fields
                        if (!exists(form.fieldMap.tname[field.table])) {// map to hold all fields within an object of their respective table's name
                            form.fieldMap.tname[field.table] = {};
                        }
                        form.fieldMap.tname[field.table][field.name] = field;
                    }
                }
                if (exists(page.Fields)) {
                    page.Fields.forEach(field => {
                        field.istabDisabled = page.istabDisabled;
                        pushFields(field);
                    });
                }
                function loadTab(_tab) {
                    _tab.istabDisabled = !tmxUtility.checkTabPermission(_tab.TabId, page.ProductId, 'Edit');
                    var tab = loadPage(_tab, form.fieldMap, errorControl, peripherals);
                    tab.istabDisabled = _tab.istabDisabled;
                    if (tmxUtility.checkTabPermission(tab.id, page.ProductId, 'View')) {
                        form.insertTab(tab);
                    }
                }
                if (exists(page.Tabs)) {
                    page.Tabs.forEach(loadTab);

                    if (angular.isDefined(form) && angular.isDefined(form.tabs) && form.tabs.length > 0) {
                        var culture = localStorage.getItem('culture');
                        var direction = culture == "ar" ? "rtl" : "ltr";
                        if (direction == "rtl") {
                            form.tabs = form.tabs.reverse();
                            form.tabs[(form.tabs.length) - 2].isSelected = true;
                        }
                    }


                }
                return form;
            }

            function formatFieldID(id) {
                return "tf" + id;
            }

            function decoratePage(page) {
                if (page.TabId) {
                    page.title = page.FieldLabel;
                    page.id = page.TabId;
                }
            }

            function decorateField(field) {
                if (!exists(field.type)) {
                    if (exists(field.FieldType) && field.FieldType.length > 0) {
                        field.type = field.FieldType;
                    }
                    else if (exists(field.FieldTypeLkp) && field.FieldTypeLkp > 0) {
                        var fieldType = function (item) {
                            return item.HiddenValue == field.FieldTypeLkp;
                        };
                        field.type = fieldTypeLookup.find(fieldType).VisibleValue;
                    }
                }
                field.type = field.type.toLowerCase();
            }

            function takeOutAllChilds(rootObject, objectToTraverse, name = null) {
                function takeOutChild(rootObject, objectToTraverse, name = null) {

                    if (!exists(objectKeys)) {
                        objectKeys = [];
                    }
                    if (!exists(objectToTraverse)) return;
                    if (Object.prototype.toString.call(objectToTraverse) == '[object Object]') {
                        Object.keys(objectToTraverse).forEach(function (key) {
                            if (Object.prototype.toString.call(objectToTraverse[key]) == '[object Object]' || Object.prototype.toString.call(objectToTraverse[key]) == '[object Array]') {
                                var rootObjectKey;
                                rootObjectKey = name + "." + key;

                                if (Object.prototype.toString.call(objectToTraverse[key]) == '[object Object]') {
                                    rootObject[rootObjectKey] = [];
                                    rootObject[rootObjectKey][0] = objectToTraverse[key];
                                    if (objectKeys.indexOf(rootObjectKey) < 0) {
                                        objectKeys.push(rootObjectKey)
                                    }
                                }
                                else {
                                    rootObject[rootObjectKey] = objectToTraverse[key];
                                }
                                takeOutChild(rootObject, objectToTraverse[key], rootObjectKey);
                            }
                        });
                    }
                    else if (Object.prototype.toString.call(objectToTraverse) == '[object Array]') {
                        for (var i = 0; i < objectToTraverse.length; i++) {
                            takeOutChild(rootObject, objectToTraverse[i], name + "[" + i + "]");
                        }
                    }
                }
                let objectKeys = [];
                takeOutChild(rootObject, objectToTraverse, name);
                return objectKeys;
            }

            function bindRootObjectsToChildObjects(resourceObj, objectKeys, keyThatAreActuallyObject) {
                if (!tmxUtility.exists(keyThatAreActuallyObject)) {
                    keyThatAreActuallyObject = [];
                }
                var rootKeys = Object.getOwnPropertyNames(resourceObj);

                rootKeys = rootKeys.filter(function (item) {
                    return item.includes(".");
                })
                rootKeys.splice(0, 0, ...keyThatAreActuallyObject); //Add object keys if they are defined to be at the start of the array
                rootKeys = Array.from(new Set(rootKeys)); // For keeping only distinct keys
                rootKeys.forEach(item => {
                    if (Object.prototype.toString.call(resourceObj[item]) === "[object Object]" && resourceObj[item].type) {
                        resourceObj[item] = JSON.parse(kendo.stringify(resourceObj[item]))
                    }
                    if (Object.prototype.toString.call(resourceObj[item]) === '[object Array]' && objectKeys.indexOf(item) < 0 && !(keyThatAreActuallyObject.indexOf(item) > -1)) {

                        try {
                            /*jshint evil:true */
                            eval("resourceObj." + item + " = resourceObj[item]");
                        }
                        catch (exception) {
                            console.log('Error Occured In Evaluating ' + item);
                        }
                    }
                    else if (Object.prototype.toString.call(resourceObj[item]) === '[object Array]' && (objectKeys.indexOf(item) >= 0 || keyThatAreActuallyObject.indexOf(item) > -1)) {
                        if (resourceObj[item][0]) {
                            try {
                                /*jshint evil:true */
                                eval("resourceObj." + item + " = resourceObj[item][0]");
                            }
                            catch (exception) {
                                console.log('Error Occured In Evaluating ' + item);
                            }
                        }
                    }
                });
            }

            function makeArrayToObject(rootObject, objectToArray) {
                objectToArray.forEach(function (key) {
                    if (Object.prototype.toString.call(rootObject[key]) == '[object Array]') {
                        var tempObj = angular.copy(rootObject[key][0]);
                        rootObject[key] = {};
                        rootObject[key] = tempObj;
                    }
                });
            }

            function removeEmptyObjects(rootObject) {
                Object.keys(rootObject).forEach(key => removeEmptyObjectsRecursively(rootObject, key));
            }
            function removeEmptyObjectsRecursively(object, key) {
                if (Object.prototype.toString.call(object[key]) == '[object Array]') {
                    if (object[key].length > 0) {
                        for (let i = object[key].length - 1; i <= 0; i++) { // reverse loop to work with splice
                            removeEmptyObjects(object[key][i]);
                            if (Object.keys(object[key][i]).length == 0) {
                                object[key].splice(i, 1);
                            }
                        }
                    }
                    if (object[key].length == 0) { // Check the length after removal. so no else if
                        delete object[key];
                    }
                }
                else if (Object.prototype.toString.call(object[key]) == '[object Object]') {
                    Object.keys(object[key]).forEach(objectKey => removeEmptyObjectsRecursively(object[key], objectKey));
                    if (Object.keys(object[key]).length == 0) {
                        delete object[key];
                    }
                }
            }

            function tfsManipulation(tfsObject) {
                var allFields = [];
                if (tmxUtility.exists(tfsObject.Tabs) && tfsObject.Tabs.length > 0) {
                    angular.forEach(tfsObject.Tabs, function (item) {
                        angular.forEach(item.Fields, function (obj) {
                            allFields.push(obj)
                        })
                    });
                }
                else {
                    angular.forEach(tfsObject.Fields, function (obj) {
                        allFields.push(obj)
                    });
                }

                var objectToIterage = angular.copy(allFields);

                angular.forEach(allFields, function (item) {
                    if (!item.FieldTableName.includes('.')) {
                        try {
                            item.FieldTableName = renameTableName(item);
                        }
                        catch (e) {
                            console.error(e);
                            console.error('Error in field definition', item);
                        }
                    }
                });

                function renameTableName(item) {
                    var newParentId = 0;
                    var fieldTableName = item.FieldTableName;

                    if (item._ParentFieldId) {
                        newParentId = objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0]._ParentFieldId;
                        if (objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName.includes('[]')) {
                            var tableName = angular.copy(objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName.replace('[]', ''));
                            fieldTableName = tableName + '[0].' + item.FieldTableName.replace('[]', '');
                        }
                        else {
                            fieldTableName = objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName + '.' + item.FieldTableName.replace('[]', '');
                        }
                    }


                    while (newParentId) {
                        var baseObj = objectToIterage.filter(obj => obj.TenantFieldSetupId == newParentId)[0].FieldName;
                        if (baseObj == 'TmxPerson') {
                            fieldTableName = baseObj + '.' + fieldTableName;
                        }
                        else {
                            fieldTableName = baseObj + '[0].' + fieldTableName;
                        }

                        newParentId = objectToIterage.filter(obj => obj.TenantFieldSetupId == newParentId)[0]._ParentFieldId
                    }


                    var FinalName = fieldTableName.replace('TmxGuarantor[0].', '');
                    FinalName = FinalName.replace('TmxGuarantor.', '');
                    return FinalName;
                }
            }

        }]);
})();//file end